$(document).on('turbolinks:load', function() {
const searchInput = document.querySelector('input#query');
  
  searchInput.addEventListener('keypress', function(event) {
    if (searchInput.value.length != 0) {
      document.querySelector('.latest-resources').style.display = "none";
    }
    
    if (event.key === 'Enter') {
      event.preventDefault(); // This prevents a default form submit if desired
      searchInput.form.submit(); // Programmatically submit the form
    }
  });
});